module.exports = __webpack_public_path__ + "img/2.237b8adf.png";